import { Link } from "react-router-dom";
import { useState, useRef } from "react";
import { Overlay, Popover } from "react-bootstrap";

/* room4 침실 */

function Room6(){

  const [showFrontPopover, setShowFrontPopover] = useState(false);
  const [FrontPopoverText, setFrontPopoverText] = useState('');
  const FrontRef = useRef(null);

  const handleFrontClick = () => {
  setFrontPopoverText("열려있다");
  setShowFrontPopover(true);
  setTimeout(() => setShowFrontPopover(false), 2000);
};


    return(
        <div
      className="d-flex justify-content-center align-content-center" 
        style={{height: 'calc(100vh - 200px)',
        alignItems: 'center',
        gap: '30px',
        marginTop: '-17vh',
         }}>
          <div className="d-flex flex-row align-items-center" style={{ gap: '0px' }}>
        <button
          ref={FrontRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleFrontClick}
          style={{
            width: '30vw',
            height: '30vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderTopRightRadius: '0',
            borderBottomRightRadius: '0'
          }}
          >문</button>

          <button
          className="btn btn-dark"
          style={{
            width: '1vw',
            height: '30vh',
            backgroundColor: 'black',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderTopLeftRadius: '0',
            borderBottomLeftRadius: '0',
            padding: 0,
            textDecoration: 'none'
          }}aria-label="그림자 영역 클릭 시 이동"
          >
          <span style={{ width: '100%', height: '100%' }}></span>
        </button>
          </div>

          {FrontRef.current && (
          <Overlay target={FrontRef.current} show={showFrontPopover} placement="top">
            {(props) => (
              <Popover {...props}>
                <Popover.Body>{FrontPopoverText}</Popover.Body>
              </Popover>
            )}
          </Overlay>
        )}

          {/* 화면 정중앙 링크 */}
      <div
        className="d-grid gap-2 col-8 col-sm-6 col-md-4 col-lg-2 mx-auto"
        style={{
          position: 'absolute',
          top: '80%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          gap: '1rem',       // 버튼 사이 간격 (1rem = 16px 기본)
        }}
      >
        <Link to="/coffin" className="btn btn-secondary">
          들어간다
        </Link>
        <button type="button" className="btn btn-secondary" disabled>
          들어가지 않는다
        </button>
      </div>


          </div>
       );
}

export default Room6;

